import { render, staticRenderFns } from "./confirmSignUp.vue?vue&type=template&id=6b6849d6&scoped=true&"
import script from "./confirmSignUp.vue?vue&type=script&lang=js&"
export * from "./confirmSignUp.vue?vue&type=script&lang=js&"
import style0 from "./confirmSignUp.vue?vue&type=style&index=0&id=6b6849d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6849d6",
  null
  
)

export default component.exports